var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('bulletinBoard',{attrs:{"dialogVisible":_vm.isbulletinBoard},on:{"handClose":_vm.handClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }